var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoLogout = function SvgIcoLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M4.254 7.667h5a.836.836 0 0 0 .833-.834A.836.836 0 0 0 9.254 6h-5c-.917 0-1.667.75-1.667 1.667v11.666c0 .917.75 1.667 1.667 1.667h5a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834h-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "m17.295 13.208-2.325-2.325a.417.417 0 0 0-.716.292v1.492H8.42a.836.836 0 0 0-.833.833c0 .458.375.833.833.833h5.834v1.492c0 .375.45.558.708.292l2.325-2.325a.41.41 0 0 0 .008-.584"
  })));
};
export default SvgIcoLogout;